export enum CursorMode {
	None = 'none',
	Select = 'select',
	Move = 'move',
	EditIslandLayout = 'edit-island-layout'
}
